/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::aptos_coin::mint`. */
export const mint = "0x1::aptos_coin::mint" as const;

/** Script function type for `0x1::aptos_coin::claim_mint_capability`. */
export const claim_mint_capability =
  "0x1::aptos_coin::claim_mint_capability" as const;

/** Script function type for `0x1::aptos_coin::delegate_mint_capability`. */
export const delegate_mint_capability =
  "0x1::aptos_coin::delegate_mint_capability" as const;
